import { makeVar } from '@apollo/client';

export const showConfetti = makeVar(false);
